var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nslide"},_vm._l((_vm.DisForm.infoList),function(i,index){return _c('a',{key:index,class:{"curs":_vm.DisForm.curIndex==index},attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.see(index)}}},[_c('span',[_vm._v(_vm._s(_vm.htit))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }